export default "__VITE_ASSET__xUkOYzEX__"